

<ng-container *ngIf="this.parkerStateService.filteredParkers.length === 0 && this.parkerStateService.parkerQueryPerformed === true">
    <div style="margin-top:20px;margin-left:20px;height:30px;">
        <span style="font-size:larger;font-weight:400">No Parkers To display from search</span>
    </div>
</ng-container>

      
<ng-container *ngIf="this.parkerStateService.filteredParkers.length === 0 && this.parkerStateService.parkerQueryPerformed === false">
    <div style="margin-top:20px;margin-left:20px;height:30px;">
        <span style="font-size:larger;font-weight:400">Enter criteria and perform a search above to view results</span>
    </div>
</ng-container>

<ng-container *ngIf="this.parkerStateService.filteredParkers.length > 0">

<div class="row" style="margin-bottom:5px;text-align: left;margin-top:1px;">
    <div class="col-8">
        <mat-slide-toggle color="accent" style="margin-left:30px;" (click)="onToggleDisplayMassUpdate()"><span class="ace-title-level-1">Mass Update Tool</span></mat-slide-toggle>
    </div>
    <!-- <div class="col-4" style="padding-right:20px;text-align: left;">
        <mat-accordion class="example-headers-align" multi style="position:relative; top: 0px;margin-right:20px;">
            <mat-expansion-panel>
            <mat-expansion-panel-header style="background-color: #003087;color:white;">
                <mat-panel-title>
                <span  class="ace-heading-text-level-2" style="color:white;">Parker Grid Options</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mt-4 mb-3">
                <div class="col-4">
                   
                </div>
                <div class="col-4">
                   
                </div>
                <div class="col-4">
                   
            </div>
            </div>
            <hr class="mt-3"/>
            <div class="row">
                <div class="col-12">
                    <div class="row" style="position:relative;top:5px;margin-bottom:5px;">
                        <span style="font-weight:bold;margin-top:5px;">Adjust font size:</span>
                        <div class="col-6">
                            <button style="margin-left:15px;" mat-icon-button color="primary" aria-label="Decrease Font Size" (click)="onFontSizeChange('-')" >
                                <mat-icon class="icon_display_small" style="color: #003087;">text_decrease</mat-icon>
                            </button>
                        </div>
                        <div class="col-6">
                            <button mat-icon-button color="primary" aria-label="Increase Font Size"  (click)="onFontSizeChange('+')">
                                <mat-icon class="icon_display_large"  style="color: #003087;">text_increase</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12" style="height:125px;">
                    <hr />
                    <span style="font-weight:bold;">Choose Display Style:</span>
                    <select id="selectQSRLayout"  class="form-select" 
                    aria-label="QSR Grid Layout Selection" 
                    style="margin-top:15px;font-size:12px;width:200px;margin-right:5px;position:relative;top:-5px;margin-bottom:5px;"
                    [ngModel]="gridViewSelection"
                    (change)="onToggleShowGridColumns()" >
                    <option [value]="0" >
                        Full View
                    </option>
                    <option [value]="1" >
                        Compact View
                    </option>
                    <option [value]="2" >
                        spACE View
                    </option>
                    <option [value]="3" >
                        Comments View
                    </option>
                    <option [value]="4" >
                        Vehicle View
                    </option>
                    <option [value]="5" >
                        Emails View
                    </option>
                    </select>
                </div>
            </div>
            
            </mat-expansion-panel>
        </mat-accordion>
    </div> -->
</div>

<ng-container *ngIf="massUpdateDisplay">
    <app-parkers-v2-massupdate></app-parkers-v2-massupdate>
</ng-container>


</ng-container>


<ng-container  *ngIf="this.parkerStateService.parkerQueryResults.length > 0 && this.parkerStateService.modeAddNew == false">

    <mat-tab-group mat-stretch-tabs="false"  style="margin-left:20px;margin-right:20px;margin-top:0px;margin-bottom:20px;" >

       <mat-tab style="border: 1px">

            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon mr-2"  style="margin-right:5px;">group</mat-icon>
                <span class="ace-heading-text-tabs-level-1">
                    Parker Search Results: {{this.parkerStateService.filteredParkers.length}}
                </span>
            </ng-template>
            <app-parkers-v2-grid-view-main></app-parkers-v2-grid-view-main>
        </mat-tab>

        <mat-tab label=>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon mr-2" style="margin-right:5px;">published_with_changes</mat-icon>
                <span class="ace-heading-text-tabs-level-1">
                    Mass Update Status: {{this.parkerStateService.parkerUpdateList.length}}
                </span>
            </ng-template>
            <ng-container *ngIf="!this.parkerStateService.parkerUpdateList.length">
                No Parker Profiles have been selected for updates...
            </ng-container>
            <ng-container *ngIf="this.parkerStateService.parkerUpdateList.length">
                <app-parkers-v2-grid-view-mass-update></app-parkers-v2-grid-view-mass-update>
            </ng-container>
        </mat-tab>

        <mat-tab label=>
            <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon mr-2"  style="margin-right:5px;">cloud_download</mat-icon>
                <span class="ace-heading-text-tabs-level-1">
                    Export: {{this.parkerStateService.filteredParkers.length}}
                </span>
            </ng-template>
            <div style="height:100%;">
                <app-parkers-v2-grid-view-export></app-parkers-v2-grid-view-export>
            </div>
        </mat-tab>
    </mat-tab-group>
</ng-container>


